import { ref, readonly } from 'vue'
import { v2 } from '@/services/api.js'

// Global Variables
const communicationStatus = ref([])
const conversionStatus = ref([])
const priority = ref([])
const status = ref([])
const subject = ref([])
const type = ref([])

export function useTasksPicklist() {
  try {
    v2.get('/tasks/picklists')
      .then(response => {
        communicationStatus.value = response.data.communicationStatus
        conversionStatus.value = response.data.conversionStatus
        priority.value = response.data.priority
        status.value = response.data.status
        subject.value = response.data.subject
        type.value = response.data.type
      })
  } catch (error) {
    console.error(error)
  }

  return {
    // Variables
    communicationStatusPicklist: readonly(communicationStatus),
    conversionStatusPicklist: readonly(conversionStatus),
    priorityPicklist: readonly(priority),
    statusPicklist: readonly(status),
    subjectPicklist: readonly(subject),
    typePicklist: readonly(type)

    // Functions
  }
}